import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaFileLines } from "react-icons/fa6";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import ViewDocument from "../../components/viewDocument/ViewDocument";
import { allRoutes } from "../../routes/routes";
import CommonTextInput from "../../components/common/commonTextInput/CommonTextInput";
import CommonDropDown from "../../components/common/commonDropDown/CommonDropDown";
import {
  ADD_REMOVE_WISHLIST,
  DELETE_DOCUMENT_DETAILS,
  DOWNLOAD_DOCUMENT_DETAILS,
  GET_COUNTRY_LIST,
  GET_DOCUMENT_DETAILS,
  GET_DOCUMENT_FIELDS_LIST,
  GET_DOCUMENT_TYPE_LIST,
  GET_FAMILY_DOCUMENT_LIST,
  GET_MEMBER_LIST,
  GET_RELATION_LIST,
  GET_WISHLIST,
  getNotificationListAction,
} from "../../redux/actions/CommonActions";
import {
  NUMBER_OF_FAVOURITES_LIMIT,
  getDocumentTypeSvgIcon,
  getGlobalSearchData,
  getServerImageUrl,
} from "../../constants/constants";
import CustomToast from "../../toastify/CustomToast";
import i18n from "../../i18n/i18n";
import { getPersonalProfileDataAction } from "../../redux/actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import { getUserDataSelelctor } from "../../redux/selectors/AuthSelectors";
import {
  getDocumentListByDocTypeSelector,
  getDocumentListByFamilySelector,
  getDocumentListSelector,
  getExpiredDocumentListByDocTypeSelector,
  getExpiredDocumentListByFamilySelector,
  getFavouriteListSelector,
  getSelectedDocumentType,
} from "../../redux/selectors/CommonSelectors";
import { DOCUMENT_TYPE_SELECTION } from "../../redux/reducers/commonReducer";
import { getDocFieldTranslationKey, sendDataToReducer } from "../../helpers/CommonHelpers";

const ExpiredDocuments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const documentListByDocType = useSelector(getExpiredDocumentListByDocTypeSelector);
  const documentListByDocFamily = useSelector(getExpiredDocumentListByFamilySelector);
  const documentType = useSelector(getSelectedDocumentType);
  const documentList = useSelector(getDocumentListSelector);

  const favoriteList = useSelector(getFavouriteListSelector);
  const userData = useSelector(getUserDataSelelctor);

  const [selectedDocumentType, setDocumentType] = useState(documentType);
  const [selectedDocument, setSelectedDocument] = useState([]);
  const [documentInfo, setDocInfo] = useState({});
  const [wishListLoader, setWishListLoader] = useState(false);
  const [imageData, setImageData] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [allDocs, setAllDocs] = useState([]);
  const [text, setText] = useState("");

  const documentData = text
    ? getGlobalSearchData(
      allDocs,
      ["name", "doc_type_name", "family_member_name"],
      text
    )
    : documentListByDocType;
  const familyData = text
    ? getGlobalSearchData(
      allDocs,
      ["name", "doc_type_name", "family_member_name"],
      text
    )
    : documentListByDocFamily;


  const getData = async () => {
    dispatch(getPersonalProfileDataAction());
  };

  useEffect(() => {
    dispatch(getNotificationListAction());
    getData();
    API_Function();
  }, []);

  useEffect(() => {
    getAllDocData();
  }, [documentListByDocType]);

  useEffect(() => {
    dispatch(GET_WISHLIST());
  }, [wishListLoader]);

  const handleDownload = async () => {
    const zip = new JSZip();

    const urls = [
      "https://maskaside-doxbox.s3.amazonaws.com/64468397b7b83/606733420DOC.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUAK774FQYZDDSD5H%2F20230817%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20230817T051948Z&X-Amz-SignedHeaders=host&X-Amz-Expires=3600&X-Amz-Signature=fefa2b55e661f0445505e6187641815c1ed50a12880d72650e9fcd41f2c33e96",
      "https://maskaside-doxbox.s3.amazonaws.com/64468397b7b83/606733420DOC.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUAK774FQYZDDSD5H%2F20230817%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20230817T051948Z&X-Amz-SignedHeaders=host&X-Amz-Expires=3600&X-Amz-Signature=fefa2b55e661f0445505e6187641815c1ed50a12880d72650e9fcd41f2c33e96",
    ];
    for (const url of urls) {
      if (url?.includes("pdf")) {
        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            zip.file(url, blob);
          })
          .catch((error) => {
            console.error("Error downloading file:", error);
          });
      } else {
        fetch(url, {
          headers: {
            Accept: "*/*",
            "Accept-Encoding": "gzip, deflate, br",
            "Content-Type": "image/jpeg",
            mode: "cors",
            credentials: "include",
          },
        })
          .then((response) => response.blob())
          .then((blob) => {
            console.log("vszv", blob);
            zip.file(url, blob);
          })
          .catch((error) => {
            console.error("Error downloading image:", error);
          });
      }
    }

    zip.generateAsync({ type: "blob" }).then((content) => {
      console.log("szzx", content);
      saveAs(content, "files.zip");
    });
  };

  const getAllDocData = async () => {
    const wholeData = [];
    const promise = documentListByDocType.map((childrenOne) =>
      Promise.all(
        childrenOne?.list?.map((childrenTwo) =>
          Promise.all(
            childrenTwo.document_list.map((item) => wholeData.push(item))
          )
        )
      )
    );
    await Promise.all(promise)
      .then(() => {
        setAllDocs(wholeData);
      })
      .catch(() => {
        setAllDocs([]);
      });
  };

  const API_Function = () => {
    dispatch(GET_FAMILY_DOCUMENT_LIST());
    dispatch(GET_WISHLIST());
    dispatch(GET_RELATION_LIST());
    dispatch(GET_MEMBER_LIST());
    dispatch(GET_DOCUMENT_TYPE_LIST());
    dispatch(GET_COUNTRY_LIST());
  };

  const selectDoc_ShareFun = (document) => {
    const selectedDocId = document?.doc_id;
    if (selectedDocument != "") {
      const ind = selectedDocument.findIndex(
        (x) => x?.doc_id === selectedDocId
      );
      if (ind == -1) {
        setSelectedDocument([...selectedDocument, document]);
      } else {
        setSelectedDocument(
          selectedDocument.filter((x) => x.doc_id !== selectedDocId)
        );
      }
    } else {
      setSelectedDocument([...selectedDocument, document]);
    }
  };

  const add_remove_FavoriteFun = (item) => {
    const data = {
      user_id: userData?.id || 0,
      document_id: item?.doc_id || 0,
      family_member_id: item?.family_member_id || 0,
      document_type_id: item?.doc_type_id || 0,
    };
    setWishListLoader(true);
    const favItemIndex = favoriteList?.findIndex(
      (fitem) =>
        fitem?.doc_id === data?.document_id &&
        fitem?.doc_type_id === data?.document_type_id &&
        fitem?.family_member_id === data?.family_member_id
    );
    if (
      favItemIndex >= 0 ||
      favoriteList?.length < NUMBER_OF_FAVOURITES_LIMIT
    ) {
      dispatch(ADD_REMOVE_WISHLIST(data, favoriteList)).then((response) => {
        CustomToast.success(response?.message);
        setWishListLoader(false);
      });
    } else {
      CustomToast.error(i18n.t("favoritelist_is_full"));
    }
  };

  const onEditPress = () => {
    navigate(allRoutes.editDocument, { state: { documentInfo, imageData, fieldList: localDocumentFieldsList2 } });
  };
  const [localDocumentFieldsList2, setLocalDocumentFieldsList2] = useState([]);
  const onDownloadImage = (litem) => {
    dispatch(DOWNLOAD_DOCUMENT_DETAILS(litem))
      .then((res) => {
        setImageData(res);
      })
      .catch((e) => {
        CustomToast.error(e?.message ?? i18n.t("something_went_wrong"));
      });
    dispatch(GET_DOCUMENT_FIELDS_LIST(litem?.doc_type_id)).then(({ response }) => {

      if (response?.length > 0) {
        const fieldList = [...response];
        setLocalDocumentFieldsList2(fieldList || []);
      }
    });
    dispatch(GET_DOCUMENT_DETAILS(litem?.doc_id)).then((response) => {
      setDocInfo({
        ...litem,
        ...response,
      });
    });

  };

  const selectAll_doc = (isSelected) => {
    if (isSelected) {
      setSelectedDocument(allDocs);
    } else {
      setSelectedDocument([]);
    }
  };

  const onDeletePress = () => {
    dispatch(DELETE_DOCUMENT_DETAILS(documentInfo?.doc_id))
      .then((res) => {
        CustomToast.success(i18n.t("document_delete_successfully"));
        API_Function();
        window.location.reload();
        setSelectedDocument([]);
      })
      .catch((e) => {
        CustomToast.error(i18n.t("something_went_wrong"));
      });
  };

  const onSharePress = () => {
    if (selectedDocument?.length > 0) {
      navigate(allRoutes.shareLink, { state: { selectedDocument } });
    }
  };
  const [openDocTypes, setOpenDocTypes] = useState({});
  const [openFamilyTypes, setOpenFamilyTypes] = useState({});
  const toggleDocType = (docTypeId) => {
    setOpenDocTypes((prev) => ({
      ...prev,
      [docTypeId]: !prev[docTypeId],
    }));
  };
  const toggleFamilyType = (docTypeId) => {
    setOpenFamilyTypes((prev) => ({
      ...prev,
      [docTypeId]: !prev[docTypeId],
    }));
  };

  const Meta_Lang = getDocFieldTranslationKey()
  return (
    <>
      <div className="row flex-wrap">
        <div className="col body-content-main-clr">
          <div className="row h-100">
            <div
              className={`col-lg-${Object.keys(documentInfo)?.length > 0 ? 9 : 12
                } col-md-12 h-100 border-end`}
            >
              <div className="main-content-section">
                <div className="top-heading-bs mt-5 position-relative">
                  <h3>Expired {i18n.t(`documents`)}</h3>
                  <div className="icons-rgt-bs d-flex">
                    {selectedDocument?.length > 0 && (
                      <>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={handleDownload}
                          className="ad_bt_end me-2"
                        >
                          <i className="bi bi-download" />
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={onSharePress}
                          className="ad_bt_end me-2"
                        >
                          <i className="bi bi-share" />
                        </div>
                      </>
                    )}
                    <Link to={allRoutes.addDocument} className="ad_bt_end me-2">
                      <i className="bi bi-plus-lg" />
                    </Link>
                  </div>
                </div>
                {documentListByDocType?.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginRight: "10%",
                      marginTop: "2%"
                    }}
                  >
                    <CommonDropDown
                      selectValue={i18n.t("select")}
                      style={{ width: "30%", cursor: "pointer" }}
                      name="resident"
                      id="doc_type"
                      data={[
                        { name: `${i18n.t('document_type')}` },
                        { name: `${i18n.t('family_members')}` },
                      ]}
                      value={selectedDocumentType}
                      onChange={(e) => {
                        sendDataToReducer(
                          dispatch,
                          DOCUMENT_TYPE_SELECTION,
                          e.target.value
                        );
                        setDocumentType(e.target.value);
                      }}
                    />
                    <div
                      style={{}}
                      className="header-right-serch position-relative me-3"
                    >
                      <CommonTextInput
                        type="text"
                        name=""
                        id=""
                        value={text}
                        onChange={(t) => setText(t.target.value)}
                        placeholder={i18n.t('search')}
                      />
                      <i className="bi bi-search" />
                    </div>
                  </div>
                )}
                {selectedDocumentType !== `${i18n.t('family_members')}` ? (
                  <div
                    className="table-responsive mt-4 collapse-tbl-flx"
                    id="docktype"
                  >
                    <div
                      style={{
                        height: "500px",
                        overflowY: "scroll",
                      }}
                    >
                      <table className="table table-condensed">
                        {documentData?.length > 0 && (
                          <thead>
                            <tr>
                              <th style={{ width: 280 }}>
                                <div className="d-flex">
                                  <div
                                    onClick={() => {
                                      setSelectAll(!selectAll);
                                      selectAll_doc(!selectAll);
                                    }}
                                  >
                                    <CommonTextInput
                                      type="checkbox"
                                      id="checkall"
                                      name="chckall"
                                      className="me-2"
                                      style={{
                                        accentColor: "#FC374E",
                                        cursor: "pointer",
                                      }}
                                      checked={
                                        allDocs?.length ==
                                        selectedDocument?.length
                                      }
                                    />
                                  </div>
                                  <span>{i18n.t('select_all')}</span>
                                </div>
                              </th>
                              <th style={{ width: 180 }} />
                            </tr>
                          </thead>
                        )}
                        {[
                          ...documentList
                            .map(d => documentData.find(item => item.doc_type_id === d.id))
                            .filter(Boolean),
                          ...documentData.filter(
                            item => !documentList.some(d => d.id === item.doc_type_id)
                          ),
                        ]?.map((item) => {
                          const isSelected = favoriteList?.find(
                            (selectedDoc) => selectedDoc?.doc_id == item.doc_id
                          );
                          const shareSelected = selectedDocument?.find(
                            (selectedDoc) => selectedDoc?.doc_id == item.doc_id
                          );
                          return (
                            <tbody>
                              {text ? (
                                <tr>
                                  <td colSpan={5} className="hiddenRow p-0 m-0">
                                    <div
                                      className="collapse show"
                                      id="collapseExample"
                                    >
                                      <table className="table  table-condensed">
                                        <tbody>
                                          <tr>
                                            <td style={{ width: 290 }}>
                                              <div className="user-d-info d-flex align-items-center">
                                                <div
                                                  onClick={() =>
                                                    selectDoc_ShareFun(item)
                                                  }
                                                >
                                                  <CommonTextInput
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    type="checkbox"
                                                    id="checkall"
                                                    name="chckall"
                                                    checked={shareSelected}
                                                    className="me-2 checkoption"
                                                  />
                                                </div>
                                                {/* <div
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    add_remove_FavoriteFun(
                                                      item
                                                    );
                                                  }}
                                                >
                                                  {!isSelected ? (
                                                    <i className="bi bi-star ms-2 me-2" />
                                                  ) : (
                                                    <i
                                                      className="bi bi-star-fill ms-2 me-2"
                                                      style={{
                                                        color: "#FFB400",
                                                      }}
                                                    />
                                                  )}
                                                </div> */}
                                                <div
                                                  style={{
                                                    flex: 1,
                                                  }}
                                                  onClick={() =>
                                                    onDownloadImage(item)
                                                  }
                                                >
                                                  {console.log('item==>',item)
                                                  }
                                                  <FaFileLines size={15} />
                                                  <span className="ms-2">
                                                    {item?.name}
                                                  </span>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                <>
                                  <tr>
                                    <td colSpan={5} className="p-1">
                                      <div className="btn-colps-mn">
                                        <div
                                          className="btn collap_btn_intable ps-0 p-2 w-100"
                                          onClick={() => toggleDocType(item?.doc_type_id)}
                                          style={{ cursor: "pointer" }}
                                        >

                                          <div className="d-flex justify-content-between w-100">
                                            <div className="d-flex">

                                              <img
                                                src={getDocumentTypeSvgIcon(
                                                  item?.doc_type_id
                                                )}
                                                style={{
                                                  // backgroundColor: "#ff685a",
                                                  borderRadius: 12.5,
                                                }}
                                                alt=""
                                                height={25}
                                                width={25}
                                              />
                                              <div
                                                style={{
                                                  alignSelf: "center",
                                                  marginLeft: 10,
                                                }}
                                              >

                                                {`${item?.[Meta_Lang]} (${item?.total_document || 0
                                                  })`}
                                              </div>
                                            </div>
                                            {openDocTypes[item?.doc_type_id] ? (
                                              <i className="bi bi-chevron-up ms-2" />
                                            ) : (
                                              <i className="bi bi-chevron-down ms-2" />
                                            )}
                                          </div>


                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                  {openDocTypes[item?.doc_type_id] &&
                                    item?.list?.map((litem) => {
                                      return (
                                        <tr>
                                          <td
                                            colSpan={5}
                                            className="hiddenRow p-0 m-0"
                                          >

                                            {litem?.document_list?.map(
                                              (ritem) => {
                                                const isSelected =
                                                  favoriteList?.find(
                                                    (selectedDoc) =>
                                                      selectedDoc?.doc_id ==
                                                      ritem.doc_id
                                                  );
                                                const shareSelected =
                                                  selectedDocument?.find(
                                                    (selectedDoc) =>
                                                      selectedDoc?.doc_id ==
                                                      ritem.doc_id
                                                  );
                                                return (
                                                  <div
                                                    className="collapse show"
                                                    id="collapseExample"
                                                  >
                                                    <table className="table  table-condensed">
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{ width: 290 }}
                                                          >
                                                            <div className="user-d-info d-flex align-items-center">
                                                              <div
                                                                onClick={() =>
                                                                  selectDoc_ShareFun(
                                                                    ritem
                                                                  )
                                                                }
                                                              >
                                                                <CommonTextInput
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  type="checkbox"
                                                                  id="checkall"
                                                                  name="chckall"
                                                                  checked={
                                                                    shareSelected
                                                                  }
                                                                  className="me-2 checkoption"
                                                                />
                                                              </div>
                                                              {/* <div
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                onClick={() => {
                                                                  add_remove_FavoriteFun(
                                                                    ritem
                                                                  );
                                                                }}
                                                              >
                                                                {!isSelected ? (
                                                                  <i className="bi bi-star ms-2 me-2" />
                                                                ) : (
                                                                  <i
                                                                    className="bi bi-star-fill ms-2 me-2"
                                                                    style={{
                                                                      color:
                                                                        "#FFB400",
                                                                    }}
                                                                  />
                                                                )}
                                                              </div> */}
                                                              <div
                                                                style={{
                                                                  flex: 1,
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                onClick={() =>
                                                                  onDownloadImage(
                                                                    ritem
                                                                  )
                                                                }
                                                              >
                                                                {litem?.image_url ? (
                                                                  <img
                                                                    src={getServerImageUrl(
                                                                      litem?.image_url
                                                                    )}
                                                                    style={{
                                                                      backgroundColor:
                                                                        "#ff685a",
                                                                      borderRadius: 12.5,
                                                                    }}
                                                                    alt=""
                                                                    height={25}
                                                                    width={25}
                                                                  />
                                                                ) : (
                                                                  <div className="user-profile-document">
                                                                    <span className="usr-nm-tx">{`${userData
                                                                      ?.first_name?.[0] ??
                                                                      ""
                                                                      }${userData
                                                                        ?.last_name?.[0] ??
                                                                      ""
                                                                      }`}</span>
                                                                  </div>
                                                                )}
                                                                <span className="ms-2">
                                                                  {/* {console.log('ritem',litem.litem)
                                                                } */}
                                                                  {litem?.name}{' '}
                                                                  {ritem?.name}
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </>
                              )}
                            </tbody>
                          );
                        })}
                      </table>
                    </div>
                  </div>
                ) : (
                  <div
                    className="table-responsive mt-4 collapse-tbl-flx"
                    id="familymember"
                  >
                    <div
                      style={{
                        height: "500px",
                        overflowY: "scroll",
                      }}
                    >
                      <table className="table table-condensed">
                        {familyData?.length > 0 && (
                          <thead>
                            <tr>
                              <th style={{ width: 290 }}>
                                <div className="d-flex">
                                  <div
                                    onClick={() => {
                                      setSelectAll(!selectAll);
                                      selectAll_doc(!selectAll);
                                    }}
                                  >
                                    <CommonTextInput
                                      type="checkbox"
                                      id="checkall"
                                      name="chckall"
                                      className="me-2"
                                      checked={
                                        allDocs?.length ==
                                        selectedDocument?.length
                                      }
                                      style={{ accentColor: "#FC374E" }}
                                    />
                                  </div>
                                  <span>Select All</span>
                                </div>
                              </th>
                              <th style={{ width: 190 }} />
                            </tr>
                          </thead>
                        )}
                        {familyData?.map((item) => {


                          const isSelected = favoriteList?.find(
                            (selectedDoc) => selectedDoc?.doc_id == item.doc_id
                          );
                          const shareSelected = selectedDocument?.find(
                            (selectedDoc) => selectedDoc?.doc_id == item.doc_id
                          );
                          return (
                            <tbody>
                              {text ? (
                                <tr>
                                  <td colSpan={5} className="hiddenRow p-0 m-0">
                                    <div
                                      className="collapse show"
                                      id="collapseExample"
                                    >
                                      <table className="table">
                                        <tbody>
                                          <tr>
                                            <td style={{ width: 290 }}>
                                              <div
                                                onClick={() => { }}
                                                className="user-d-info d-flex align-items-center"
                                              >
                                                <div
                                                  onClick={() =>
                                                    selectDoc_ShareFun(item)
                                                  }
                                                >
                                                  <CommonTextInput
                                                    type="checkbox"
                                                    id="checkall"
                                                    name="chckall"
                                                    checked={shareSelected}
                                                    className="me-2 checkoption"
                                                  />
                                                </div>
                                                {/* <div
                                                  onClick={() => {
                                                    add_remove_FavoriteFun(
                                                      item
                                                    );
                                                  }}
                                                >
                                                  {!isSelected ? (
                                                    <i className="bi bi-star ms-2 me-2" />
                                                  ) : (
                                                    <i
                                                      className="bi bi-star-fill ms-2 me-2"
                                                      style={{
                                                        color: "#FFB400",
                                                      }}
                                                    />
                                                  )}
                                                </div> */}
                                                <div
                                                  style={{
                                                    flex: 1,
                                                  }}
                                                  onClick={() =>
                                                    onDownloadImage(item)
                                                  }
                                                >
                                                  <FaFileLines size={15} />
                                                  <span className="ms-2">
                                                    {item?.name}
                                                  </span>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                <>
                                  <tr>
                                    <td colSpan={4} className="p-0">
                                      <div className="btn-colps-mn">
                                        <div
                                          className="btn collap_btn_intable collapsed ps-0 p-2 d-flex"
                                          data-bs-toggle="collapse"
                                          to="#collapseExample3"
                                          role="button"
                                          aria-expanded="false"
                                          aria-controls="collapseExample3"
                                          onClick={() => toggleFamilyType(item?.id)}
                                        >

                                          <div className="d-flex justify-content-between w-100">
                                            <div className="d-flex">
                                              <div className="user-d-info d-flex align-items-center ms-0">
                                                {item?.image_url ? (
                                                  <img
                                                    src={getServerImageUrl(
                                                      item?.image_url
                                                    )}
                                                    style={{
                                                      backgroundColor: "#ff685a",
                                                      borderRadius: 12.5,
                                                    }}
                                                    alt=""
                                                    height={25}
                                                    width={25}
                                                  />
                                                ) : (
                                                  <div className="user-profile-document">
                                                    <span className="usr-nm-tx">{`${userData?.first_name?.[0] ??
                                                      ""
                                                      }${userData?.last_name?.[0] ??
                                                      ""
                                                      }`}</span>
                                                  </div>
                                                )}
                                                <span
                                                  style={{ marginRight: 4 }}
                                                  className="ms-2"
                                                >
                                                  {item?.name}
                                                </span>
                                                ({item?.total_document || 0})
                                              </div>

                                            </div>
                                            {openFamilyTypes[item?.id] ? (
                                              <i className="bi bi-chevron-up ms-2" />
                                            ) : (
                                              <i className="bi bi-chevron-down ms-2" />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                  {openFamilyTypes[item?.id] &&
                                    item?.list?.map((litem) => {
                                      return (
                                        <tr>
                                          <td
                                            colSpan={5}
                                            className="hiddenRow p-0 m-0"
                                          >

                                            {litem?.document_list?.map(
                                              (ritem) => {
                                                const isSelected =
                                                  favoriteList?.find(
                                                    (selectedDoc) =>
                                                      selectedDoc?.doc_id ==
                                                      ritem.doc_id
                                                  );
                                                const shareSelected =
                                                  selectedDocument?.find(
                                                    (selectedDoc) =>
                                                      selectedDoc?.doc_id ==
                                                      ritem.doc_id
                                                  );
                                                return (
                                                  <div
                                                    className="collapse show"
                                                    id="collapseExample"
                                                  >
                                                    <table className="table  table-condensed">
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{ width: 290 }}
                                                          >
                                                            <div
                                                              onClick={() => { }}
                                                              className="user-d-info d-flex align-items-center"
                                                            >
                                                              <div
                                                                onClick={() =>
                                                                  selectDoc_ShareFun(
                                                                    ritem
                                                                  )
                                                                }
                                                              >
                                                                <CommonTextInput
                                                                  type="checkbox"
                                                                  id="checkall"
                                                                  name="chckall"
                                                                  checked={
                                                                    shareSelected
                                                                  }
                                                                  className="me-2 checkoption"
                                                                />
                                                              </div>
                                                              {/* <div
                                                                onClick={() => {
                                                                  add_remove_FavoriteFun(
                                                                    ritem
                                                                  );
                                                                }}
                                                              >
                                                                {!isSelected ? (
                                                                  <i className="bi bi-star ms-2 me-2" />
                                                                ) : (
                                                                  <i
                                                                    className="bi bi-star-fill ms-2 me-2"
                                                                    style={{
                                                                      color:
                                                                        "#FFB400",
                                                                    }}
                                                                  />
                                                                )}
                                                              </div> */}
                                                              <div
                                                                style={{
                                                                  flex: 1,
                                                                }}
                                                                onClick={() =>
                                                                  onDownloadImage(
                                                                    ritem
                                                                  )
                                                                }
                                                              >
                                                                <img
                                                                  src={getDocumentTypeSvgIcon(
                                                                    ritem?.doc_type_id
                                                                  )}
                                                                  // style={{
                                                                  //   backgroundColor:
                                                                  //     "#ff685a",
                                                                  // }}
                                                                  alt=""
                                                                  height={25}
                                                                  width={25}
                                                                />
                                                                <span className="ms-2">
                                                                  {/* {console.log('name', ritem)
                                                                  }
                                                                  {console.log('litem', litem.doc_type_id == ritem.doc_type_id ? litem?.[Meta_Lang] : null)
                                                                  } */}
                                                                  {litem.doc_type_id == ritem.doc_type_id ? litem?.[Meta_Lang] : null}
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </>
                              )}
                            </tbody>
                          );
                        })}
                      </table>
                    </div>
                  </div>
                )}
                {/* {documentListByDocType?.length > 0 && (
                  <div className="pagination-block-cls d-flex align-items-center justify-content-end">
                    Rows per page:
                    <CommonDropDown
                      name="pagination"
                      id="pagination-count"
                      className="ms-2"
                      data={[{ name: "1" }, { name: "2" }, { name: "3" }]}
                    />
                    <p className="m-0 ms-4">1-10 of 15</p>
                  </div>
                )} */}
              </div>
              {(documentListByDocType?.length == 0 ||
                documentListByDocFamily?.length == 0) && (
                  <div style={{ height: 200 }} className={"main-content"}>
                    <p
                      style={{
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      No Data
                    </p>
                  </div>
                )}
            </div>
            {console.log('documentInfo',documentInfo)
            }
            {Object.keys(documentInfo)?.length > 0 && (
              <div className="col-lg-3 col-md-6 h-100">
                <ViewDocument
                  onEditPress={onEditPress}
                  onDeletePress={onDeletePress}
                  onSharePress={() =>
                    navigate(allRoutes.shareLink, {
                      state: { selectedDocument: [documentInfo] },
                    })
                  }
                  onClosePress={() => { setDocInfo({}); setLocalDocumentFieldsList2([]); }}
                  docInfo={documentInfo}
                  imageData={imageData}
                  fieldList={localDocumentFieldsList2}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpiredDocuments;
